import {createSelector} from '@reduxjs/toolkit';
import type {RootState} from 'src/redux/store';
import {Balance} from 'src/models/Balance';

export const selectAccountSlice = (state: RootState) => state.account;

export const selectAccount = createSelector(
  [selectAccountSlice],
  (accountState) => accountState.account,
);

export const selectAccountId = createSelector(
  [selectAccount],
  (account) => account.id || '',
);

export const selectDefaultBalance = createSelector(
  [selectAccount],
  (account) => account.defaultBalance as Balance | null,
);

export const selectDefaultBalanceAmount = createSelector(
  [selectDefaultBalance],
  (defaultBalance) => defaultBalance?.balance ?? 0,
);

export const selectAccountEmail = createSelector(
  [selectAccount],
  (account) => account.email || '',
);

export const selectAccountPoints = createSelector(
  [selectAccount],
  (account) => account.points ?? 0,
);

export const selectAccountLocationId = createSelector(
  [selectAccount],
  (account) => account.locationId || '',
);

export const selectAccountDefaultBalanceId = createSelector(
  [selectDefaultBalance],
  (defaultBalance) => defaultBalance?.id || '',
);

export const selectIsHomeLocationSma = createSelector(
  [selectAccountSlice],
  (accountState) => Boolean(accountState.isHomeLocationSma),
);

export const selectSmaBalance = createSelector(
  [selectAccount],
  (account) => account.smaBalance as Balance | null,
);

export const selectAccountBalanceId = createSelector(
  [selectIsHomeLocationSma, selectDefaultBalance, selectSmaBalance],
  (isHomeLocationSma, defaultBalance, smaBalance) =>
    isHomeLocationSma
      ? smaBalance?.id || defaultBalance?.id || ''
      : defaultBalance?.id || '',
);
